import { createSelector, createSlice } from "@reduxjs/toolkit";
import { setInitialState } from "../../../store/InitialState";

const INITIAL_STATE = setInitialState({
	data: null,
	isFetching: false,
	isSuccess: false,
	isError: false,
	error: null,
});

const caseFeedbackConfigSlice = createSlice({
	name: "caseFeedbackConfigSlice",
	initialState: INITIAL_STATE,
	reducers: {
		caseFeedbackConfigRequest: (state) => {
			state.isFetching = true;
		},
		caseFeedbackConfigSuccess: (state, action) => {
			state.isFetching = false;
			state.isSuccess = true;
			state.data = action.payload;
		},
		caseFeedbackConfigFailuer: (state, action) => {
			state.isFetching = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.payload;
		},
		resetCaseFeedbackConfig: (state) => {
			state.data = null;
			state.error = null;
			state.isError = false;
			state.isFetching = false;
			state.isSuccess = false;
		},
	},
});

export const { caseFeedbackConfigRequest, caseFeedbackConfigSuccess, caseFeedbackConfigFailuer, resetCaseFeedbackConfig } = caseFeedbackConfigSlice.actions;

export default caseFeedbackConfigSlice.reducer;